var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Alert, Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, IconButton, LoadingButton, SkeletonLine, } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { Close } from '@one-thd/sui-icons';
import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { cancellationPolicyURL, CANCEL_ALERT_MESSAGE, returnPolicyURL, remorseCancelPeriod, } from '../../../constants/cancels';
import { useExperienceContext } from '../../../hooks/useContexts';
import { CmsCreateCancel } from '../../../hooks/cancel-items-hooks';
import '../../../styles/drawer.scss';
import { pushErrorEvent, setPageInfo } from '../../../utils/analytics';
import { getWindow } from '../../../utils/general';
import { putOrderInSessionStorage } from '../../../utils/shared/RetrieveOrderDetailsUtils';
import { CDLineItemCardSkeleton } from '../../cancel-items/cancel-skeleton/CancelItemsSkeleton';
import { trackCancelButtonSubmission, trackPostRemorsePartialCancel, trackRequestCancelOverlay, } from '../../../utils/cancels/analytics';
import { CDLineItemCard } from './CDLineItemCard';
export var CancellationDrawer = function (props) {
    var _a;
    var open = props.open, onClose = props.onClose, isCancelItemsPage = props.isCancelItemsPage, cancelAllItems = props.cancelAllItems, orderDetailsData = props.orderDetailsData, orderDetailsRequestParams = props.orderDetailsRequestParams, cancelInfo = props.cancelInfo, drawerLineItems = props.drawerLineItems, isPostRemorse = props.isPostRemorse, STHorBOSSAlert = props.STHorBOSSAlert, drawerSummaryUpdate = props.drawerSummaryUpdate;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var _b = useState(false), loading = _b[0], setLoading = _b[1]; // For Loading Button
    var _c = useState(true), isSkeletonLoading = _c[0], setSkeletonLoading = _c[1]; // For Skeleton
    var _d = useThdCustomer(), isLoggedIn = _d.isLoggedIn, isExchangeCustomer = _d.isExchangeCustomer;
    var isAuthTHDUser = isLoggedIn && !isExchangeCustomer;
    var alertState = {
        status: 'info',
        alertMessage: '',
    };
    if (cancelInfo.isError || (!cancelInfo.isOrderCancelable && !isPostRemorse)) {
        alertState.alertTitle = 'error';
        alertState.status = 'error';
        alertState.alertMessage = CANCEL_ALERT_MESSAGE.ERROR;
    }
    else if (STHorBOSSAlert) {
        alertState.alertTitle = 'STHBOSS';
        alertState.status = 'info';
        alertState.alertMessage = '';
    }
    else if (isPostRemorse && !cancelInfo.isOrderCancelable) {
        trackPostRemorsePartialCancel(orderDetailsData);
        alertState.alertTitle = 'postRemorseFail';
        alertState.status = 'error';
        alertState.alertMessage = '';
    }
    var isIos = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.navigator.userAgent.includes('Mac');
    var isIosMobile = isIos && isConsumerApp;
    var lineItems = cancelAllItems
        ? drawerLineItems
        : drawerLineItems === null || drawerLineItems === void 0 ? void 0 : drawerLineItems.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.canceledQuantity) !== 0; });
    var navigate = useNavigate();
    var onSubmit = function () {
        if (isPostRemorse) {
            trackCancelButtonSubmission(orderDetailsData);
        }
        setLoading(true);
        var cmsCreateRequest = {
            orderId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
            emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
            orderVersion: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.versionId,
            net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
            lineItems: lineItems.map(function (item) {
                var _a;
                return ({
                    id: item === null || item === void 0 ? void 0 : item.lineId,
                    fulfillmentType: item === null || item === void 0 ? void 0 : item.fulfillmentType,
                    qtyToCancel: cancelAllItems
                        ? item === null || item === void 0 ? void 0 : item.maxCancelQuantity
                        : item === null || item === void 0 ? void 0 : item.canceledQuantity,
                    skuCode: item === null || item === void 0 ? void 0 : item.skuNumber,
                    storeNumber: item === null || item === void 0 ? void 0 : item.storeNumber,
                    isPRCR: item === null || item === void 0 ? void 0 : item.isPRCR,
                    omsId: (item === null || item === void 0 ? void 0 : item.isPRCR) ? (_a = item === null || item === void 0 ? void 0 : item.omsId) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.secOmsId : undefined,
                    poNumber: (item === null || item === void 0 ? void 0 : item.isPRCR) ? item === null || item === void 0 ? void 0 : item.poNumber : undefined,
                    isDFCSourced: (item === null || item === void 0 ? void 0 : item.isPRCR) ? item === null || item === void 0 ? void 0 : item.isDFCSourced : undefined,
                    workOrderNumber: item === null || item === void 0 ? void 0 : item.workOrderNumber,
                    fulfillmentVendorNumber: (item === null || item === void 0 ? void 0 : item.isPRCR) && (item === null || item === void 0 ? void 0 : item.isDFCSourced)
                        ? item === null || item === void 0 ? void 0 : item.fulfillmentVendorNumber
                        : undefined,
                    lineParentId: item === null || item === void 0 ? void 0 : item.lineParentId,
                    lineComboType: item === null || item === void 0 ? void 0 : item.lineComboType,
                    isBossPostShipped: (item === null || item === void 0 ? void 0 : item.isBossPostShipped) !== undefined
                        ? item.isBossPostShipped
                        : undefined, // Exists if PRCR BOSS item, undefined otherwise
                });
            }),
        };
        var lineCancelIdsAndQtys = lineItems.map(function (item) { return ({
            lineId: item === null || item === void 0 ? void 0 : item.lineId,
            canceledQuantity: cancelAllItems
                ? item === null || item === void 0 ? void 0 : item.maxCancelQuantity
                : item === null || item === void 0 ? void 0 : item.canceledQuantity,
            workOrderNumber: item === null || item === void 0 ? void 0 : item.workOrderNumber,
        }); });
        cancelInfo.lineCancelIdsAndQtys = lineCancelIdsAndQtys;
        cancelInfo.isSTHorBOSSQtyCancel = false;
        var path = '/myaccount/cancel-items';
        if (!isLoggedIn)
            path = '/myaccount/cancel-items?guestAccess=true';
        CmsCreateCancel(cmsCreateRequest, isAuthTHDUser, cancelInfo.xAuthGuestToken, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId)
            .then(function (response) {
            var data = response.data;
            if (data.data.cancellationRequested) {
                if (isCancelItemsPage && drawerSummaryUpdate) {
                    drawerSummaryUpdate(cancelInfo);
                }
                else {
                    putOrderInSessionStorage(orderDetailsData);
                    navigate(path, {
                        state: { orderDetailsRequestParams: orderDetailsRequestParams, cancelInfo: cancelInfo },
                    });
                }
            }
            else {
                cancelInfo.isOrderCancelable = false;
                if (isCancelItemsPage && drawerSummaryUpdate) {
                    pushErrorEvent('cancel items', 'n/a', CANCEL_ALERT_MESSAGE.ERROR, 'inline');
                    drawerSummaryUpdate(cancelInfo);
                }
                else {
                    setPageInfo('error', 'page', 'order details>cancel items', CANCEL_ALERT_MESSAGE.ERROR, 'n/a');
                    putOrderInSessionStorage(orderDetailsData);
                    navigate(path, {
                        state: { orderDetailsRequestParams: orderDetailsRequestParams, cancelInfo: cancelInfo },
                    });
                }
            }
        })
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .catch(function (_error) {
            var _a, _b, _c;
            cancelInfo.isError = true;
            var errorCode = ((_b = (_a = _error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors[0].code.toString())
                ? ((_c = _error.response) === null || _c === void 0 ? void 0 : _c.data).errors[0].code.toString()
                : 'n/a';
            if (isCancelItemsPage && drawerSummaryUpdate) {
                pushErrorEvent('cancel items', errorCode, CANCEL_ALERT_MESSAGE.ERROR, 'inline');
                drawerSummaryUpdate(cancelInfo);
            }
            else {
                setPageInfo('error', 'page', 'order details>cancel items', CANCEL_ALERT_MESSAGE.ERROR, errorCode);
                putOrderInSessionStorage(orderDetailsData);
                navigate(path, {
                    state: { orderDetailsRequestParams: orderDetailsRequestParams, cancelInfo: cancelInfo },
                });
            }
        });
    };
    var title = "".concat(isPostRemorse ? 'Request to Cancel Entire Order' : 'Items to Cancel');
    useLayoutEffect(function () {
        if (open && isPostRemorse) {
            trackRequestCancelOverlay();
        }
    }, [open]);
    useEffect(function () {
        if (drawerLineItems) {
            setSkeletonLoading(false);
        }
    }, [drawerLineItems]);
    var modifiedLineItems = __spreadArray([], lineItems.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.lineParentId) === undefined;
    }), true);
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-full sui-gap-4 sui-w-96" },
        React.createElement(Drawer, { open: open, onClose: onClose, position: "right" },
            React.createElement(DrawerHeader, { title: title, endAdornment: React.createElement(IconButton, { "aria-label": "drawer-close", onClick: onClose, icon: Close }) }),
            React.createElement(DrawerBody, null,
                React.createElement("div", { className: "cancel-drawer-body sui-flex sui-flex-col sui-full sui-gap-4" },
                    isSkeletonLoading ? (React.createElement("div", null, alertState && React.createElement(SkeletonLine, null))) : (React.createElement(React.Fragment, null,
                        alertState.alertTitle && alertState.alertTitle === 'error' && (React.createElement(Alert, { status: alertState.status }, alertState.alertMessage)),
                        alertState.alertTitle &&
                            alertState.alertTitle === 'STHBOSS' &&
                            remorseCancelPeriod && (React.createElement(Alert, { status: alertState.status },
                            "Individual items may be cancelled within",
                            ' ',
                            remorseCancelPeriod,
                            " minutes of receiving your order confirmation email. See our",
                            ' ',
                            React.createElement("a", { className: "sui-underline", href: cancellationPolicyURL }, "Cancellation Policy"),
                            ' ',
                            "for details.")),
                        alertState.alertTitle &&
                            alertState.alertTitle === 'postRemorseFail' && (React.createElement(Alert, { status: alertState.status },
                            "The item(s) scheduled for delivery can't be cancelled. See our",
                            ' ',
                            React.createElement("a", { className: "sui-underline", href: returnPolicyURL }, "Returns Policy"),
                            ' ',
                            "for more options.")))),
                    React.createElement("div", { className: "sui-overflow-y-auto responsive-overflow" }, isSkeletonLoading ? (React.createElement(CDLineItemCardSkeleton, null)) : (React.createElement(React.Fragment, null, modifiedLineItems.map(function (item, i) { return (React.createElement(React.Fragment, null,
                        React.createElement(CDLineItemCard, { cancellationItem: item, cancelAllItems: cancelAllItems }),
                        i !== lineItems.length - 1 && (React.createElement("hr", { className: "line-item-divider" })))); })))))),
            React.createElement(DrawerFooter, null, isSkeletonLoading ? (React.createElement(SkeletonLine, { variant: "single" })) : (React.createElement(React.Fragment, null,
                !cancelInfo.isError && (cancelInfo === null || cancelInfo === void 0 ? void 0 : cancelInfo.isOrderCancelable) && (React.createElement("div", { className: classNames('card-fix', {
                        'ios-bottom-fix': isIosMobile,
                    }) },
                    React.createElement(LoadingButton, { onClick: onSubmit, loading: loading }, isPostRemorse === true
                        ? 'Submit Request to Cancel'
                        : 'Confirm Items to Cancel'))),
                (cancelInfo.isError || !cancelInfo.isOrderCancelable) && (React.createElement("div", { className: classNames('card-fix', {
                        'ios-bottom-fix': isIosMobile,
                    }) },
                    React.createElement(Button, { variant: "primary", onClick: function () {
                            if (isLoggedIn) {
                                navigate('/myaccount/purchase-history');
                            }
                            else {
                                window.location.href =
                                    '/myaccount/guest-order-tracking';
                            }
                        } }, "Back to Online Orders")))))))));
};
